export function removePriceLeadingZero(price) {
  var _priceParts$;
  var priceParts = price.toString().split('.');
  var haveDecimalPlaces = (_priceParts$ = priceParts[1]) === null || _priceParts$ === void 0 ? void 0 : _priceParts$.length;
  if (!haveDecimalPlaces) {
    return "".concat(parseFloat(price).toFixed(0));
  }
  var integerPart = priceParts[0];
  var decimalPart = priceParts[1];
  return "".concat(+integerPart, ".").concat(decimalPart);
}
export function isGreaterThanTwoDecimalPlaces(num) {
  var _String$split$;
  return ((_String$split$ = String(num).split('.')[1]) === null || _String$split$ === void 0 ? void 0 : _String$split$.length) > 2;
}
export function formatTipAmount(price) {
  if (!price) return '0';
  if (isGreaterThanTwoDecimalPlaces(price)) {
    return String(price).slice(0, -1);
  }
  var convertedPrice = removePriceLeadingZero(price);
  if (+convertedPrice >= 0) {
    return "".concat(convertedPrice);
  }
  return '0';
}